<template>
  <client-only>
    <ul class="text-center" v-if="timer">
      <li>
        <span>{{ timer.days }}</span> Days
      </li>
      <li>
        <span>{{ timer.hours }}</span> Hours
      </li>
      <li>
        <span>{{ timer.minutes }}</span> Mins
      </li>
      <li>
        <span>{{ timer.seconds }}</span> Secs
      </li>
    </ul>
  </client-only>
</template>

<script>
import { useTimer } from "vue-timer-hook";

export default {
  props: {
    endDate: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const endTime = new Date(props.endDate);
    const endTimeMs = endTime.getTime();
    const timer = useTimer(endTimeMs);

    return {
      timer,
    };
  },
};
</script>
